import { render, staticRenderFns } from "./TaskRevoked.vue?vue&type=template&id=725c6d72&"
import script from "./TaskRevoked.vue?vue&type=script&lang=js&"
export * from "./TaskRevoked.vue?vue&type=script&lang=js&"
import style0 from "./TaskRevoked.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports